 
namespace TabAurous.Retail {
    import fld = POSApprovalReturnBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class POSApprovalReturnBOMEditor extends _Ext.BOMGridEditor<POSApprovalReturnBOMRow> { 
        protected getDialogType() { return POSApprovalReturnBOMDialog; }
        protected getLocalTextPrefix() { return POSApprovalReturnBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSApprovalReturnItemsDialog).CalculateTotals();
                }
            });
        } 
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }  
    }
}